import Header from "../../header/Header";
import AuthorizedSignersInfo from "../authorized_signers_info/AuthorizedSignersInfo";
import Footer from "../../footer/Footer";

function AuthorizedSignersLanding(){
    return(
        <div className="authorized_signers_landing">
            <Header />
            <AuthorizedSignersInfo />
            <Footer />
        </div>
    )
}

export default AuthorizedSignersLanding